import { useState, useEffect } from 'react';
import fetchWidget from '#/api/chartService';
import isequal from 'lodash.isequal';

const useWidget = (endpoint, filters, localFilters, date, polling, dashboardWidgetId, ordination, exhibition, widgetBindDtos, auxiliaryOptionsDto) => {
  const [serviceData, setData] = useState(null);
  const [hasChangedFilters, setFiltersChanged] = useState(false);
  const [hasChangedWidgetBindDtos, setWidgetBindDtosChanged] = useState(false);
  const [hasChangedAuxiliaryOptionsDtos, setAuxiliaryOptionsDtoChanged] = useState(false);
  const [hasChangedDate, setDateChanged] = useState(false);
  const [isFirstTime, setFirstTime] = useState(true);

  useEffect(() => {
    setFiltersChanged(localFilters);
    setWidgetBindDtosChanged(widgetBindDtos);
    setAuxiliaryOptionsDtoChanged(auxiliaryOptionsDto);
    setDateChanged(date);
    if (isFetchNeeded()) {
      fetchData();
    }
  }, [date, localFilters, widgetBindDtos]);

  useEffect(() => {
    if (polling) {
      const intervalId = setInterval(() => {
        fetchData();
      }, polling);
      return () => clearTimeout(intervalId);
    }
  }, [polling])

  const isFetchNeeded = () =>
    polling ||
    isFirstTime ||
    !isequal(hasChangedFilters, localFilters) ||
    !isequal(hasChangedWidgetBindDtos, widgetBindDtos) ||
    !isequal(hasChangedAuxiliaryOptionsDtos, auxiliaryOptionsDto) ||
    !isequal(hasChangedDate, date);

  const fetchData = async () => {
    setData(null);
    try {
      setFirstTime(false);
      const { data } = await fetchWidget(endpoint, filters, localFilters, date, dashboardWidgetId, ordination, exhibition, widgetBindDtos, auxiliaryOptionsDto);
      setData(data);
    } catch (error) {
      console.error(`failed do get ${endpoint.endpointUrl}\n\n`, error);
    }
  };

  return {
    serviceData,
  };
};

export default useWidget;
